import React, { useState } from "react";
import { TextField, Button, Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom'
import axios from 'axios'
import { useDispatch } from "react-redux";
import { ERROR, LOADING, LOADING_OFF } from '../store/actions/UserAction'
import styled from "styled-components";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import { lightGreen } from '@material-ui/core/colors';
const greenTheme = createMuiTheme({ palette: { primary: lightGreen } })

const initialLogin = {
    fName: '',
    lName: '',
    mName: '',
    username: '',
    password: '',
    confirm: '',
}

const Form = styled.form`
    max-width: 100%;
    min-height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    background: white;
    padding: 20% 0;
    /* margin-top: 25%;
    margin-bottom: 10%; */
    /* margin-bottom: 6rem; */
    margin-top: 6rem;
    margin-bottom: 6rem;

    @media (min-width: ${props => props.theme.mobileBreakpoint}){
        max-width: 80%;
        margin-top: 6rem;
        border: 1px grey solid;
        border-radius: 1.4%;
        padding: 2% 0;
    }
    @media (min-width: ${props => props.theme.tabletBreakpoint}){
        border: 1px grey solid;
        margin-top: 3.5rem;
        /* margin-bottom: 80%; */
        border-radius: 1.4%;
        max-width: 45%;
    }
`

const StyledTF = styled(TextField)`
    width: 80%;
`

const Register = () => {

    const [register, setRegister] = useState(initialLogin)
    let history = useHistory()
    let dispatch = useDispatch()
    const inputHandler = (e) => {
        setRegister({...register, [e.target.name]: e.target.value})
    }
    const submitHandler = (e) => {
        e.preventDefault()
        dispatch({type: ERROR, payload: ``})
        // if (!register.username || !register.password || !register.fname || !register.lname || register.password !== register.confirm) return
        for (const [key, value] of Object.entries(register)) {
            if (key === "mName"){
                continue
            } else if (!value) {
                dispatch({type: ERROR, payload: `${key} cannot be empty`})
                return
            }
        }
        if (register.password !== register.confirm) {
            dispatch({type: ERROR, payload: `Password does not match`})
                return
        }
        dispatch({type: LOADING, payload: ''})
        const submittedData = {
            fname: register.fName,
            mname: register.mName,
            lname: register.lName,
            username: register.username,
            password: register.password
        }
        axios
            .post('https://kzhao-club.herokuapp.com/createnewuser', submittedData)
                .then(response => {
                    setRegister(initialLogin)
                    history.push('/')
                })
                .catch(error => {
                    dispatch({type: ERROR, payload: "That wasn't suppose to happen, try again"})
                })
                .finally(() => {
                    dispatch({type: LOADING_OFF, payload: ''})
                })
        }

        const cancelHandler = (e) => {
            e.preventDefault()
            dispatch({type: ERROR, payload: ``})
            setRegister(initialLogin)
            history.push('/')
        }
    return (
        <>
            <Form onSubmit={submitHandler}>
                <Grid container direction={"column"} spacing={2}>
                    <Grid item>
                        <h4>NGHS ENVIRONMENTAL CLUB</h4>
                    </Grid>
                    <Grid item>
                        <StyledTF 
                            label='Username'
                            variant='filled'
                            name='username'
                            value={register.username}
                            onChange={inputHandler}
                            type='text'
                        />
                    </Grid>
                    <Grid item>
                        <StyledTF 
                            label='First Name'
                            variant='filled'
                            name='fName'
                            value={register.fName}
                            onChange={inputHandler}
                            type='text'
                        />
                    </Grid>
                    <Grid item>
                        <StyledTF 
                            label='Middle Name'
                            variant='filled'
                            name='mName'
                            value={register.mName}
                            onChange={inputHandler}
                            type='text'
                        />
                    </Grid>
                    <Grid item>
                        <StyledTF 
                            label='Last Name'
                            variant='filled'
                            name='lName'
                            value={register.lName}
                            onChange={inputHandler}
                            type='text'
                        />
                    </Grid>
                    <Grid item>
                        <StyledTF
                            label='Password'
                            variant='filled'
                            name='password'
                            value={register.password}
                            onChange={inputHandler}
                            type='password'
                        />
                    </Grid>
                    <Grid item>
                        <StyledTF
                            label='Confirm'
                            variant='filled'
                            name='confirm'
                            value={register.confirm}
                            onChange={inputHandler}
                            type='password'
                        />
                    </Grid>
                    <Grid item>
                        <Grid container direction={"row"} spacing={2} justify={"center"}>
                            <MuiThemeProvider theme={greenTheme}>
                                <Grid item>
                                    <Button variant="contained" color="primary" onClick={cancelHandler}>
                                        Cancel
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button type='submit' variant='contained' color='primary'>
                                        Register
                                    </Button>
                                </Grid>
                            </MuiThemeProvider>
                        </Grid>
                    </Grid>
                </Grid>
            </Form>
        </>
    );
};

export default Register;